import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CustomOrder } from '@order/const';
import { Observable } from 'rxjs';
import { OrderDetailsComponentService } from '../../order-details.component-service';

@Component({
  selector: 'sd-summary-bonus',
  styleUrls: ['order-summary-bonus.component.scss'],
  templateUrl: 'order-summary-bonus.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class OrderSummaryBonusComponent implements OnInit {
  order$: Observable<CustomOrder>;

  constructor(private orderDetailsComponentService: OrderDetailsComponentService) {}

  ngOnInit(): void {
    this.order$ = this.orderDetailsComponentService.getOrderDetails();
  }
}
